import * as types from "../actionTypes";

export const remove = (id, { goBack = false }) => {
  return {
    type: types.MANAGER_REMOVE_RECEIVE_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = (data, deletedItemId) => {
  return {
    type: types.MANAGER_REMOVE_RECEIVE_SUCCESS,
    payLoad: { data, deletedItemId }
  };
};
export const removeFailure = (data, deletedItemId) => {
  return {
    type: types.MANAGER_REMOVE_RECEIVE_FAILURE,
    payLoad: { data, deletedItemId }
  };
};

export const store = (data, files, reload = false) => {
  return {
    type: types.MANAGER_STORE_RECEIVE_REQUEST,
    data: data,
    files: files,
    reload: reload
  };
};
export const storeSuccess = () => {
  return {
    type: types.MANAGER_STORE_RECEIVE_SUCCESS
  };
};
export const storeFailure = () => {
  return {
    type: types.MANAGER_STORE_RECEIVE_FAILURE
  };
};

export const getRequest = id => {
  return {
    type: types.MANAGER_GET_RECEIVE_REQUEST,
    id
  };
};
export const getSuccess = data => {
  return {
    type: types.MANAGER_GET_RECEIVE_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.MANAGER_GET_RECEIVE_FAILURE,
    error: error
  };
};

export const updateRequest = (id, data, files) => {
  return {
    type: types.MANAGER_UPDATE_RECEIVE_REQUEST,
    id,
    data,
    files
  };
};
export const updateSuccess = data => {
  return {
    type: types.MANAGER_UPDATE_RECEIVE_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.MANAGER_UPDATE_RECEIVE_FAILURE
  };
};

export const getImageRequest = id => {
  return {
    type: types.MANAGER_GET_IMAGE_RECEIVE_REQUEST,
    id
  };
};
export const getImageSuccess = data => {
  return {
    type: types.MANAGER_GET_IMAGE_RECEIVE_SUCCESS,
    payLoad: data
  };
};
export const getImageFailure = error => {
  return {
    type: types.MANAGER_GET_IMAGE_RECEIVE_FAILURE,
    error: error
  };
};
